import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 10000,
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('srg_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('srg_token');
      localStorage.removeItem('srg_admin');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const login = (email, password) =>
  api.post('/auth/login', { email, password }).then(r => r.data);

export const getMe = () =>
  api.get('/auth/me').then(r => r.data);

export const changePassword = (currentPassword, newPassword) =>
  api.put('/auth/change-password', { currentPassword, newPassword }).then(r => r.data);

// Projects
export const getProjects = () =>
  api.get('/projects').then(r => r.data);

export const getProject = (id) =>
  api.get(`/projects/${id}`).then(r => r.data);

export const createProject = (data) =>
  api.post('/projects', data).then(r => r.data);

export const updateProject = (id, data) =>
  api.put(`/projects/${id}`, data).then(r => r.data);

export const deleteProject = (id) =>
  api.delete(`/projects/${id}`).then(r => r.data);

// Plots
export const getPlots = (params) =>
  api.get('/plots', { params }).then(r => r.data);

export const createPlot = (data) =>
  api.post('/plots', data).then(r => r.data);

export const updatePlot = (id, data) =>
  api.put(`/plots/${id}`, data).then(r => r.data);

export const deletePlot = (id) =>
  api.delete(`/plots/${id}`).then(r => r.data);

export const getStats = () =>
  api.get('/plots/stats/summary').then(r => r.data);

// Audit
export const getAuditLogs = (page = 1) =>
  api.get('/audit', { params: { page } }).then(r => r.data);

export default api;
